module.exports = __webpack_public_path__ + "img/funding.0d2511ff.png";